module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/567cfca578d74d716678c13c5d7a2c8f.png";